import { timeInMinutes } from './time-in-minutes';
import { getPeriodTimesForDay } from './get-period-times-for-day';
import { calculateActualWorkDay } from './calculate-actual-work-day';
import { rangesMinusRanges } from './ranges-minus-ranges';
import { summarizeRanges } from './summarize-ranges';
import { validPlusTimeMinutes } from './valid-plus-time-minutes';

export function getPeriodDayData(employee, period, type, date, workScheduleException) {
  const periodData = getPeriodTimesForDay(period, date);
  let timeDisplay = periodData.startTime + '-' + periodData.endTime + periodData.unconfirmedText;
  if (periodData.startTime === '00:00' && periodData.endTime === '24:00') {
    timeDisplay = 'Hele dagen' + periodData.unconfirmedText;
  }
  let comment = '';
  let workStartInMinutes = 0;
  let workEndInMinutes = 0;
  const actualWorkDay = calculateActualWorkDay(employee, date.toString(), workScheduleException);
  if (actualWorkDay.workDay) {
    workStartInMinutes = timeInMinutes(actualWorkDay.start);
    workEndInMinutes = timeInMinutes(actualWorkDay.end);
  }
  const minutes = timeInMinutes(periodData.endTime) - timeInMinutes(periodData.startTime);
  let validMinutes = 0;
  let validHoursText = '';
  if (type === 'plusTime') {
    const plusTimeHours = Math.round((minutes / 60 + Number.EPSILON) * 100) / 100;
    const validPlusTime = validPlusTimeMinutes(
      timeInMinutes(periodData.startTime),
      timeInMinutes(periodData.endTime),
      workStartInMinutes,
      workEndInMinutes,
      employee.leavePeriods ?? [],
      date,
    );
    const validHours = Math.round((validPlusTime / 60 + Number.EPSILON) * 100) / 100;
    validMinutes = validPlusTime;
    validHoursText = validHours + ' plusstimer';
    if (!periodData.unconfirmedText) {
      timeDisplay += ' (' + validHours + 't)';
    }
    if (plusTimeHours > validHours) {
      comment = 'Plusstid innenfor vanlig arbeidstid telles ikke';
    }
  }
  if (type === 'timeOff') {
    const nonWorkRanges = rangesMinusRanges(
      [{ start: 0, end: 1440 }],
      [{ start: workStartInMinutes, end: workEndInMinutes }],
    );
    const validTimeOffRanges = rangesMinusRanges(
      [{ start: timeInMinutes(periodData.startTime), end: timeInMinutes(periodData.endTime) }],
      nonWorkRanges,
    );
    validMinutes = summarizeRanges(validTimeOffRanges);
    if (actualWorkDay.workMinutes && validMinutes > actualWorkDay.workMinutes) {
      validMinutes = actualWorkDay.workMinutes;
    }
    const validHours = Math.round((validMinutes / 60 + Number.EPSILON) * 100) / 100;
    if (!periodData.unconfirmedText) {
      timeDisplay += ' (' + validHours + 't)';
    }
    if (minutes > validMinutes) {
      comment = 'Avspasering ut over vanlig arbeidstid telles ikke';
    }
  }
  return {
    id: period.uuid,
    type,
    confirmed: period.confirmed,
    timeDisplay,
    notes: period.notes,
    comment: comment,
    item: period,
    minutes,
    validMinutes,
    validHoursText,
  };
}
